module.exports = __webpack_public_path__ + "static/media/about-us.bd4edcc0.jpg";